// =============================================================================
// CK — Admin Authentication
// -----------------------------------------------------------------------------
// Single source of truth for who counts as an admin. Every admin page should
// import isAdmin() from this file and gate access through it.
//
// Adding/removing an admin = edit the ADMINS array, redeploy. No other changes
// needed in any admin component. RLS policies on Supabase tables also need
// to reference the same UUIDs — see migration files.
//
// NOTE: each admin lists BOTH production and staging UUIDs. Supabase keeps
// a separate auth.users table per project, so the same person has different
// auth.users.id values in production vs staging. Listing both means this file
// works in both builds without environment-specific configuration. UUIDs are
// not secrets — they're identifiers — so listing them publicly is fine.
// =============================================================================

export const ADMINS = [
  {
    name: 'Tomás',
    initial: 'T',
    email: 'tomasbilbao@mac.com',
    role: 'founder',
    uuids: [
      '8eca5223-ed49-401c-9ac6-530a691286ed', // production
      '81ee59e9-34d1-4a61-87e0-c9de4f81c220', // staging
    ],
  },
  {
    name: 'Esly',
    initial: 'E',
    email: 'eslydiaz@gmail.com',
    role: 'admin',
    uuids: [
      '8adcaa35-5a46-4c8e-8aab-34efbc3aa2e1', // production
      '2c841820-5fb1-4c2f-ab5e-5c0ee6eec6e8', // staging
    ],
  },
];

// Flat list of every admin UUID across all environments.
export const ADMIN_UUIDS = ADMINS.flatMap(a => a.uuids);

/**
 * Returns true if the given Supabase user object is an admin.
 * Pass the `user` from `supabase.auth.getUser()`.
 */
export function isAdmin(user) {
  if (!user || !user.id) return false;
  return ADMIN_UUIDS.includes(user.id);
}

/**
 * Returns the admin profile (name, initial, email, role) for a given user,
 * or null if they are not an admin. Useful for displaying who's logged in
 * inside admin tools.
 */
export function getAdminProfile(user) {
  if (!user || !user.id) return null;
  return ADMINS.find(a => a.uuids.includes(user.id)) || null;
}
